import { zergApi } from "@/service/zerg";

const prefix = "/rrhh/dias-libres";

class DiasLibresService {
    async getReporteMensual(params) {
        try {
            const data = await zergApi.post(`${prefix}/reporte-mensual`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDatosPendientes(params = {}) {
        try {
            const data = await zergApi.post(`${prefix}/datos-pendientes`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async asignarRegimen(payload) {
        try {
            const data = await zergApi.post(`${prefix}/asignar-regimen`, payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getSolicitudes(params) {
        try {
            const data = await zergApi.post(`${prefix}/solicitudes`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async cotizar(payload) {
        try {
            const data = await zergApi.post(`${prefix}/cotizar`, payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async solicitar(payload) {
        try {
            const data = await zergApi.post(`${prefix}/solicitar`, payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async aprobar(payload) {
        try {
            const data = await zergApi.post(`${prefix}/aprobar`, payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async aprobarSolicitud(payload) {
        return this.aprobar(payload);
    }

    async rechazar(payload) {
        try {
            const data = await zergApi.post(`${prefix}/rechazar`, payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async rechazarSolicitud(payload) {
        return this.rechazar(payload);
    }

    async anular(payload) {
        try {
            const data = await zergApi.post(`${prefix}/anular`, payload);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async anularSolicitud(payload) {
        return this.anular(payload);
    }

    async getHistorial(params) {
        try {
            const data = await zergApi.post(`${prefix}/historial`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcel(params) {
        try {
            const response = await zergApi.post(`${prefix}/export-to-excel`, params, {
                responseType: "blob",
            });
            return response;
        } catch (error) {
            throw error;
        }
    }

    async venderDiasLibres(params) {
        try {
            const data = await zergApi.post(`${prefix}/vender`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DiasLibresService();

